import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useVideoEditorStore = defineStore('videoEditor', () => {
  // 视频元素
  const videoRef = ref<HTMLVideoElement | null>(null)
  // 视频文件url
  const videoFileUrl = ref<string | null>(null)
  // 当前播放时间
  const currentTime = ref(0)
  // 视频总时长
  const duration = ref(0)
  // 开始时间
  const startTime = ref(0)
  // 结束时间
  const endTime = ref(0)
  // 是否播放
  const isPlaying = ref(false)
  const videoFrames = ref<Array<{ ts: number; img: Blob }>>([])
  const isProcessingFrames = ref(false)

  // Actions
  const setVideoFileUrl = (url: string | null) => {
    videoFileUrl.value = url
  }

  const setCurrentTime = (time: number) => {
    currentTime.value = time
  }

  const setDuration = (time: number) => {
    duration.value = time
    endTime.value = time // 设置初始结束时间为视频总时长
  }

  const setTimeRange = (start: number, end: number) => {
    startTime.value = start
    endTime.value = end
  }

  const setIsPlaying = (playing: boolean) => {
    isPlaying.value = playing
  }

  const setVideoFrames = (frames: Array<{ ts: number; img: Blob }>) => {
    videoFrames.value = frames
  }

  const setProcessingFrames = (processing: boolean) => {
    isProcessingFrames.value = processing
  }

  const setVideoRef = (ref: HTMLVideoElement | null) => {
    videoRef.value = ref
  }

  // 更新视频时间
  const updateVideoTime = (time: number) => {
    currentTime.value = time
    // 直接更新视频元素的播放时间
    if (videoRef.value) {
      videoRef.value.currentTime = time / 1000000
    }
  }

  return {
    // State
    videoFileUrl,
    videoRef,
    currentTime,
    duration,
    startTime,
    endTime,
    isPlaying,
    videoFrames,
    isProcessingFrames,
    // Actions
    setVideoFileUrl,
    setCurrentTime,
    setDuration,
    setTimeRange,
    setIsPlaying,
    setVideoFrames,
    setProcessingFrames,
    setVideoRef,
    updateVideoTime,
  }
})